import Link from 'next/link'
import Image from 'next/image'
import CookiePreferencesLink from './CookiePreferencesLink'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-black py-10 md:py-12 border-t border-white/10 pb-safe">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 md:gap-4">
          {/* Logo / Brand */}
          <div className="flex items-center gap-3">
            <div className="relative w-8 h-8">
              <Image 
                src="/assets/images/logo V vibe.png" 
                alt="Logo Vibe" 
                fill
                className="object-contain"
              />
            </div>
            <span className="hidden md:block w-px h-6 bg-zinc-800"></span>
            <p className="text-zinc-500 text-sm font-medium">Experiências Universitárias</p>
          </div>

          {/* Links Rápidos */}
          <div className="flex flex-wrap justify-center gap-6 text-sm font-medium text-zinc-400">
            <Link href="/termos" className="hover:text-[#ffa300] transition-colors py-2">Termos de Uso</Link>
            <Link href="/privacidade" className="hover:text-[#ffa300] transition-colors py-2">Privacidade</Link>
            <Link href="/ajuda" className="hover:text-[#ffa300] transition-colors py-2">Ajuda</Link>
            <CookiePreferencesLink />
          </div>

          {/* Copyright */}
          <div className="text-zinc-600 text-xs text-center md:text-right">
            &copy; <span suppressHydrationWarning>{currentYear}</span> Vibe Ingressos. <span className="hidden md:inline">|</span> <br className="md:hidden"/>Todos os direitos reservados.
          </div>
        </div>
      </div>
    </footer>
  )
}
